import React from 'react'
import '../styles/Main.css'
import LiquidBlock from '../Blocks/LiquidBlock'
import LiquidButton from '../Blocks/LiquidButton'
import { useNavigate } from 'react-router-dom'

const Main = ({adminData}) => {
  const navigate = useNavigate()
  return (
    <section className='mainSection'>
      <h2>Здравствуйте,</h2>
      <h1>{adminData?.secondName}</h1>
      <LiquidBlock>
        <h3 className='instrAdm'>Инструменты</h3>
        <div className="adminsButtonBlock">
          {adminData?.canViewAdmins ? <LiquidButton onClick={() => navigate('/admins')}>Админы</LiquidButton> : null }
          {
            adminData?.canCreateEvent || 
            adminData?.canEditEvent ||
            adminData?.canChangeEventStatus ||
            adminData?.canDeleteMembers ? <LiquidButton onClick={() => navigate('/events')}>Мероприятия</LiquidButton> : null}
          {adminData?.canViewUsers ? <LiquidButton onClick={() => navigate('/users')}>Пользователи</LiquidButton> : null}
          {adminData?.canScanQR ? <LiquidButton onClick={() => navigate('/qrscan')}>QR-Сканер</LiquidButton> : null}
        </div>
      </LiquidBlock>
    </section>
  )
}

export default Main